import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
import { CTABand } from '../components/CTABand';
import { SERVICES, EXTRA_SERVICES } from '../lib/content';
export function Services() {
  return <>
      <PageHero eyebrow="Our Services" title={<>If it's junk, <span className="text-jk-red" data-id="element-283" data-mp="14k2p1ko2fn3">it's gone</span></>} subtitle="One crew, one trailer, and everything you need cleared out. Here's what the Kings haul." data-id="element-282" data-mp="3jhrocjvh0th5" />

      <section className="bg-jk-ink py-20" data-id="element-284" data-mp="b4kp4wdu1bvi">
        <div className="mx-auto flex max-w-7xl flex-col gap-16 px-4 sm:px-6" data-id="element-285" data-mp="b39mizw4ia5z">
          {SERVICES.map((s, i) => <motion.div key={s.slug} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className={`grid items-center gap-8 lg:grid-cols-2 ${i % 2 === 1 ? 'lg:[&>*:first-child]:order-2' : ''}`} data-id="element-286" data-mp="635434bnn5d4" data-mpi={i}>
              <div className="overflow-hidden rounded-2xl border border-white/10" data-id="element-287" data-mp="1bop78h8y3286">
                <img src={s.image} alt={s.title} className="h-72 w-full object-cover" data-id="element-288" data-mp="1fog85ds6qyqf" />
              </div>
              <div data-id="element-289" data-mp="1kh1009rj71rb">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-jk-red text-white" data-id="element-290" data-mp="1khiryu75uttf">
                  <s.icon className="h-6 w-6" data-id="element-291" data-mp="1phooanodl4hu" />
                </div>
                <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-none text-white" data-id="element-292" data-mp="1ucu89gy7w93a">{s.title}</h2>
                <p className="mt-3 text-white/65" data-id="element-293" data-mp="1zbduligq3mw6">{s.blurb}</p>
                <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-294" data-mp="23e23fq5fstt5">
                  {s.items.map(item => <li key={item} className="flex items-center gap-2 text-white/80" data-id="element-295" data-mp="50sce4uhwgzm">
                      <CheckIcon className="h-5 w-5 flex-shrink-0 text-jk-red" data-id="element-296" data-mp="923vdriv63yu" /> {item}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </section>

      <section className="bg-white py-20" data-id="element-297" data-mp="17ezs9j274upg">
        <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-298" data-mp="1ld67fhzd85zs">
          <SectionHeading light eyebrow="And More" title={<>Extra <span className="text-jk-red" data-id="element-300" data-mp="1ha00070io8rq">hauling help</span></>} data-id="element-299" data-mp="1lak11lo7nwj5" />
          <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-301" data-mp="1vakljaxtgiox">
            {EXTRA_SERVICES.map((e, i) => <motion.div key={e.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="rounded-2xl border border-black/10 bg-white p-7 shadow-sm" data-id="element-302" data-mp="1qc10dcr1raxm" data-mpi={i}>
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-jk-ink text-jk-red" data-id="element-303" data-mp="2e1vcfs3jkvgt">
                  <e.icon className="h-6 w-6" data-id="element-304" data-mp="2905yo4oxq3p1" />
                </div>
                <h3 className="mt-4 font-display text-2xl font-bold uppercase text-jk-ink" data-id="element-305" data-mp="2spc2gqcjag6m">{e.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-black/60" data-id="element-306" data-mp="2xmlpjzcgafra">{e.text}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTABand data-id="element-307" data-mp="2no67smzbciug" />
    </>;
}